import $ from 'jquery';

export default function OpenHour(vm) {
    this.all = function(params) {
        var url = '/open-hour/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/open-hour/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/open-hour/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/open-hour/force-delete/' + params.id;
        else
            url = '/open-hour/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/open-hour/restore/' + id;

        return vm.get(url);
    };
}